import { useTransition } from 'react'
import { CurecallSelect, CurecallSelectItem } from '@honestica/curecall-ui'
import { useForm } from 'react-hook-form'
import { NAVIGATION_LOCALES } from 'src/types/locales'
import { useZendesk } from 'react-use-zendesk'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLocale } from 'src/hooks/use-locale'

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation()
  const { locale } = useLocale()
  const navigate = useNavigate()
  const location = useLocation()
  const [isPending, startTransition] = useTransition()
  const { close, setLocale } = useZendesk()

  const methods = useForm({ defaultValues: { language: locale } })
  const { register } = methods

  const languagesOptions = NAVIGATION_LOCALES.map((locale) => ({
    label: t('components.language-switcher.locale', { locale }),
    value: locale,
  }))

  const onSelectChange = async (languageOption: CurecallSelectItem<string>) => {
    // Update widget language
    setLocale(languageOption.value)

    // Close widget to avoid issues during transition
    close()

    startTransition(() => {
      // Change i18n language
      i18n.changeLanguage(languageOption.value)

      // Replace locale in URL
      const newPath = location.pathname.replace(/^\/(fr|en)/, `/${languageOption.value}`)
      navigate(newPath, { replace: true })
    })
  }

  return (
    <div className="c-flex c-items-center c-gap-6 c-pb-6">
      <CurecallSelect
        {...register('language')}
        selectedItem={languagesOptions.find((option) => option.value === locale)}
        isDisabled={isPending}
        onChange={onSelectChange}
        label={t('components.language-switcher.label')}
        placeholder={t('components.language-switcher.label')}
        items={languagesOptions}
      />
    </div>
  )
}

export default LanguageSwitcher
